<template>
  <v-layout 
   pt-5
  mt-4
  justify-center>
   <v-flex xs6>
   <v-img
      :src="src"
      />
      </v-flex>
    <v-flex
      xs6  
    >
      <panel title="Password Reset Request Received.">
       <v-flex>
         Your password reset request was received.
         <br>
         If your email address is registered, you will receive an email with a link to reset your password shortly.
         </v-flex>
      </panel>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from "vuex";
import { STRONG_COLOR } from "@/components/globals/consts";
import rmp_tagline from '@/assets/rmp_tagline.png'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data() {
    return {
      strongColor: STRONG_COLOR,
      src: rmp_tagline,
      email: null
    }
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user"])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResetPasswordSubmitted.vue